import { axios } from '~/plugins/axios'

const actions = {
  async fetchPlans() {
    const resp = await axios.get('/api/reports/wfm/plans')
    return (resp.data && resp.data.data) || resp.data || []
  },

  async fetchReport(_, payload) {
    const resp = await axios.post('/api/reports/wfm/run', payload)
    return (resp.data && resp.data.data) || resp.data
  },

  async exportReport(_, payload) {
    return axios.post('/api/reports/wfm/export', payload, { responseType: 'blob' })
  },
}

export default {
  namespaced: true,
  actions,
}
